// @flow

import React from 'react';
import { Wrapper } from '@riseart/layout';
import { FilterBuilder, FilterContainerLoader } from '@riseart/filter';
import { ArtListFilterModel } from 'shared_models/filters/ArtList';
import type { FilterContainerProps } from 'shared_hocs/filters/Container';

/**
 * ArtListFilterContainer
 *
 * * @param {FilterContainerProps} props
 */
export const ArtListFilterContainer = ({ isLoading, ...restProps }: FilterContainerProps) => (
  <FilterContainerLoader component={Wrapper} isLoading={isLoading}>
    <FilterBuilder {...restProps} config={ArtListFilterModel} />
  </FilterContainerLoader>
);
